export default {"src":"/_next/static/media/Arrow-right-blue.419e44bc.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};